import Select from "react-select";
import React, { useState, useEffect } from "react";
import { getAllUsers } from "services/userServices";

const AuditFilters = ({ handleUser, toggleModal }) => {
  const [selectedUser, setSelectedUser] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const users = await getAllUsers();
        const options = users.map(user => ({
          value: user.id,
          label: `${user.first_name} ${user.last_name} (${user.user_country[0]?.country?.short_name || "N/A"})`,
        }));
        setUserOptions(options);
      } catch (error) {
        console.error("Failed to load users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleFilterApply = () => {
    handleUser(selectedUser);
    toggleModal();
  };

  return (
    <div>
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-buffer light-icon me-1" />
          <h6 className="mb-0">User:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isLoading={loading}
            options={userOptions}
            value={userOptions.find(opt => opt.value === selectedUser) || null}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select a user"
            onChange={option => setSelectedUser(option?.value || "")}
          />
        </div>
      </div>
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <button
          className="btn btn-success common-button"
          style={{ width: "90%" }}
          onClick={handleFilterApply}
          disabled={loading}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default AuditFilters;
